import { Heading } from "@chakra-ui/layout";
import { animate } from "framer-motion";
import { useEffect, useRef, useState } from "react";

import { usePrevious } from "../../hooks";
import FancyText from "../FancyText";

function Header({ result, year }) {
  const videoCountRef = useRef();

  const [from, setFrom] = useState(0);
  const [to, setTo] = useState(1);

  const prevNumber = usePrevious(to);

  // If the year changes in the bar-chart, set the video-count accordingly
  useEffect(() => {
    if (result?.totalVideosPerYear[year] && prevNumber) {
      setFrom(prevNumber);
      setTo(result.totalVideosPerYear[year]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year]);

  // This animates the video-count number
  useEffect(() => {
    const node = videoCountRef.current;

    const controls = animate(from, to, {
      duration: 1,
      onUpdate(value) {
        node.textContent = value.toFixed(0);
      },
    });

    return () => controls.stop();
  }, [from, to]);

  return (
    <>
      <Heading fontWeight={100}>I watched a total of</Heading>
      <Heading>
        <FancyText>
          <span ref={videoCountRef} />{" "}
        </FancyText>
        Videos in {year}
      </Heading>
    </>
  );
}
export default Header;
